import { render } from "./Index.vue?vue&type=template&id=d66547c6&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-d66547c6"

export default script